import { useMemo } from 'react'
import { Column } from 'react-table'
import { useTranslation } from 'react-i18next'

import SelectionTable, { SelectionTableProps } from '@/components/ui/tables/SelectionTable'
import { Chip, ChipProps } from '@mui/material'

export type StaffData = {
  id: string
  cps: string
  name: string
  surname: string
  status: 'PDS' | 'MEDECIN'
  isSameEtablissement: boolean
  stripe?: string
  stripeActivated?: boolean
}

export type StaffSelectionTableProps = Pick<SelectionTableProps<StaffData>, 'data' | 'onSelect' | 'readOnly' | 'selected'>

export function StaffSelectionTable(props: StaffSelectionTableProps) {
  const { t } = useTranslation()

  const columns = useMemo(() => {
    return [
      {
        Header: t('page.createMeetingLink.StaffSelectionTable.header.name'),
        accessor: 'name',
        width: 'unset',
      },
      {
        Header: t('page.createMeetingLink.StaffSelectionTable.header.surname'),
        accessor: 'surname',
        width: 'unset',
      },
      {
        Header: t('page.createMeetingLink.StaffSelectionTable.header.cps'),
        accessor: 'cps',
        width: 'unset',
      },
      {
        Header: t('page.createMeetingLink.StaffSelectionTable.header.status'),
        accessor: 'status',
        width: 'unset',
      },
      {
        Header: t('page.createMeetingLink.StaffSelectionTable.header.etablissement'),
        accessor: 'isSameEtablissement',
        width: 'unset',
        Cell: (row: any) => {
          const { isSameEtablissement } = row.row.original
          let color: ChipProps['color'] = 'error'
          if (isSameEtablissement) {
            color = 'success'
          }
          return (
            <>
              <Chip color={color} label={t(`page.createMeetingLink.StaffSelectionTable.field.etablissement.${isSameEtablissement}.label`)} size="small" variant="filled" />
            </>
          )
        }
      }
    ] as Column<StaffData>[]
  }, [t])

  // TODO: add staffs search and pagination

  return <SelectionTable {...props} columns={columns} />
}

export default StaffSelectionTable
